var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8711 30.2731L27.154 34.7422C27.6211 35.2396 28.1775 35.6362 28.7915 35.9092C29.4054 36.1822 30.0649 36.3263 30.7323 36.3334C31.3996 36.3404 32.0618 36.2102 32.6809 35.9502C33.3 35.6902 33.864 35.3054 34.3406 34.8179L34.4146 34.7407C35.3768 33.7562 35.9247 32.4133 35.9381 31.0073C35.9514 29.6013 35.429 28.2473 34.4858 27.2431L31.5821 24.2132M19.2287 14.9205L8.64776 3.87949L4.9572 7.73051L15.2914 18.514M35.4702 8.94551L31.0015 13.5888L25.7749 8.17137L30.2465 3.52651C29.215 3.05999 28.0802 2.89907 26.9668 3.06142C24.9009 3.24658 22.9803 4.24626 21.5958 5.85698C20.2113 7.46771 19.4671 9.56841 19.5146 11.7315C19.5058 12.5824 19.6598 13.4265 19.9675 14.2145L5.65973 27.3689C4.67735 28.2832 4.08325 29.5673 4.0081 30.9387C3.93296 32.31 4.38292 33.6564 5.25902 34.6816C5.29241 34.7225 5.32726 34.7604 5.3621 34.7998C5.79549 35.2721 6.31381 35.6507 6.88746 35.9139C7.46111 36.1772 8.07883 36.3199 8.70536 36.334C9.33188 36.348 9.95492 36.2332 10.5389 35.9959C11.1229 35.7587 11.6563 35.4037 12.1088 34.9512C12.2539 34.8089 12.3901 34.6571 12.5167 34.4968L25.1854 19.635C26.5394 20.05 27.9635 20.1533 29.3594 19.938C30.8304 19.6208 32.1906 18.8908 33.2934 17.8267C34.3963 16.7627 35.2001 15.4048 35.6183 13.8994C36.0929 12.2761 36.0409 10.5348 35.4702 8.94551Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWhite);
export default __webpack_public_path__ + "static/media/settings-white.122e8d73.svg";
export { ForwardRef as ReactComponent };